import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faYoutube,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/jriit-logo-cropped.png";

const Footer = () => {
  return (
    <footer className="bg-custom-pink text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Logo and Social Media */}
          <div className="col-span-1 lg:col-span-1 flex flex-col items-center">
            <img
              src={logo}
              alt="College Logo"
              className="mb-4 h-52" // Adjust negative margin
            />
            <div className="flex space-x-4 mb-4 text-md justify-center">
              {" "}
              {/* Center icons */}
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gold"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gold"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gold"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gold"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gold"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>
          </div>

          {/* Other sections remain unchanged */}
          <div className="col-span-1 leading-loose">
            <h3 className="text-xl font-bold mb-4 border-l-2 border-gold pl-3">
              Contact Information
            </h3>
            <p>Jr Institute Of Information Technology</p>
            <p>Sakina Area Arusha Tanzania</p>
            <p>P. O. Box 7071 Namanga Road.</p>
            <p>Tel1: +255 754 360 590</p>
            <p>Tel2: +255 679 414 415</p>
            <p>
              Email:{" "}
              <a
                href="mailto:principal@jriit.ac.tz"
                target="_blank"
                rel="noreferrer"
              >
                principal@jriit.ac.tz
              </a>
            </p>
            <p>
              Email:{" "}
              <a
                href="mailto:admin@jriit.ac.tz"
                target="_blank"
                rel="noreferrer"
              >
                admin@jriit.ac.tz
              </a>
            </p>
            <p>
              Email:{" "}
              <a href="mailto:marketing@jriit.ac.tz">marketing@jriit.ac.tz</a>
            </p>
            <p>
              Website:{" "}
              <a
                href="https://www.jriit.ac.tz"
                target="_blank"
                className="hover:text-gold"
                rel="noreferrer"
              >
                https://www.jriit.ac.tz
              </a>
            </p>
          </div>

          {/* Useful Links */}
          <div className="col-span-1 leading-loose">
            <h3 className="text-xl font-bold mb-4 border-l-2 border-gold pl-3">
              Useful Links
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.comptia.org"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  CompTIA
                </a>
              </li>
              <li>
                <a
                  href="https://www.netacad.com/"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  CISCO Networking Academy
                </a>
              </li>
              <li>
                <a
                  href="https://www.eccouncil.org/"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  EC-Council
                </a>
              </li>
              <li>
                <a
                  href="https://www.nacte.go.tz"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  NACTE
                </a>
              </li>
              <li>
                <a
                  href="https://www.tcu.go.tz"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  TCU
                </a>
              </li>
              <li>
                <a
                  href="https://www.moe.go.tz"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  MOE
                </a>
              </li>
              <li>
                <a
                  href="https://www.veta.go.tz"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  VETA
                </a>
              </li>
              <li>
                <a
                  href="https://www.heslb.go.tz"
                  target="_blank"
                  className="hover:text-gold"
                  rel="noreferrer"
                >
                  HESLB
                </a>
              </li>
            </ul>
          </div>

          {/* Admission Info */}
          <div className="col-span-1 leading-loose">
            <h3 className="text-xl font-bold mb-4 border-l-2 border-gold pl-3">
              Admission
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/admissions" className="hover:text-gold">
                  Academic Calendar
                </a>
              </li>
              <li>
                <a href="/admissions" className="hover:text-gold">
                  Prospectus
                </a>
              </li>
              <li>
                <a href="/fees" className="hover:text-gold">
                  Fee Structure
                </a>
              </li>
              <li>
                <a href="/course/short-courses" className="hover:text-gold">
                  Short Courses
                </a>
              </li>
              <li>
                <a href="/about/terms-conditions" className="hover:text-gold">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>

          {/* Small Map Widget */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4 border-l-2 border-gold pl-3">
              Where We Are
            </h3>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15931.805561943684!2d36.660178!3d-3.362054!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x18371c56dc7ed7ed%3A0xc47ab61515db909e!2sJr%20Institute%20of%20Information%20Technology!5e0!3m2!1ssw!2stz!4v1729119469120!5m2!1ssw!2stz"
              width="100%"
              height="250"
              allowFullScreen=""
              loading="lazy"
              title="Google Map"
              className="rounded-lg"
            ></iframe>
          </div>
        </div>

        {/* Copyright Notice */}
        <div className="border-t border-gray-700 pt-8 text-center">
          <p>
            &copy; 2025 Jr Institute Of Information Technology. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
